
//Generated File
//Do not modify by hand, it will get overwritten
//see smapply generate_js_viewnames for what you want
var viewnames = {
    "account": "/acc/",
    "admin-account-delete-request-cancel": "/acc/del/cncl/",
    "admin-activity": "/admin/activity/",
    "admin-activity-datasource": "/admin/activity/datasource/",
    "admin-award-permanently-delete": "/admin/awards/pdel/",
    "admin-awards-add": "/admin/awards/add/",
    "admin-awards-application-detail": "/admin/awards/<pk>/manage/applications/<submission_id>/view/",
    "admin-awards-application-edit-customfields": "/admin/awards/<pk>/manage/applications/<submission_id>/editcustomfields/",
    "admin-awards-application-get-customfields": "/admin/awards/<pk>/manage/applications/<submission_id>/customfields/",
    "admin-awards-application-rename": "/admin/awards/<pk>/manage/rename/<app_id>/",
    "admin-awards-applications": "/admin/awards/<pk>/manage/applications/",
    "admin-awards-applications-archive": "/admin/awards/<pk>/manage/archive/",
    "admin-awards-applications-assigned-columns": "/admin/awards/<award_id>/assigned/columns/",
    "admin-awards-applications-awarded-columns": "/admin/awards/<award_id>/awarded/columns/",
    "admin-awards-applications-columns": "/admin/awards/<award_id>/columns/",
    "admin-awards-applications-datasource": "/admin/awards/<award_id>/datasource/",
    "admin-awards-applications-delete": "/admin/awards/<pk>/manage/delete/",
    "admin-awards-applications-delete-permanent": "/admin/awards/<pk>/manage/delete/permanent/",
    "admin-awards-applications-delete-permanent-single": "/admin/awards/<pk>/manage/delete/permanent/single/",
    "admin-awards-applications-export": "/admin/awards/<pk>/manage/export/",
    "admin-awards-applications-hide": "/admin/awards/<pk>/manage/hide/",
    "admin-awards-applications-hide-decision": "/admin/awards/<pk>/manage/hide-decision/",
    "admin-awards-applications-labels": "/admin/awards/<pk>/manage/labels/update/",
    "admin-awards-applications-labels-checkboxes": "/admin/awards/<pk>/manage/labels/checkboxes/",
    "admin-awards-applications-labels-create": "/admin/awards/<pk>/manage/labels/create/",
    "admin-awards-applications-labels-delete": "/admin/awards/<pk>/manage/labels/delete/",
    "admin-awards-applications-labels-rename": "/admin/awards/<pk>/manage/labels/rename/",
    "admin-awards-applications-lock": "/admin/awards/<pk>/manage/lock/",
    "admin-awards-applications-new": "/admin/awards/<pk>/manage/new/",
    "admin-awards-applications-reopen": "/admin/awards/<pk>/manage/reopen/",
    "admin-awards-applications-restore": "/admin/awards/<pk>/manage/restore/",
    "admin-awards-applications-revert": "/admin/awards/<pk>/manage/revert/",
    "admin-awards-applications-show-decision": "/admin/awards/<pk>/manage/show-decision/",
    "admin-awards-applications-stages": "/admin/awards/<pk>/manage/stages/",
    "admin-awards-applications-status": "/admin/awards/<pk>/manage/status/",
    "admin-awards-applications-status-update": "/admin/awards/<pk>/manage/updatestatus/",
    "admin-awards-applications-submit": "/admin/awards/<pk>/manage/submit/",
    "admin-awards-applications-taskrecord-delete": "/admin/awards/<pk>/manage/applications/taskrecord/delete/<task_record_id>/",
    "admin-awards-applications-taskrecord-edit": "/admin/awards/<pk>/manage/applications/taskrecord/edit/<task_record_id>/",
    "admin-awards-applications-unarchive": "/admin/awards/<pk>/manage/unarchive/",
    "admin-awards-applications-unhide": "/admin/awards/<pk>/manage/unhide/",
    "admin-awards-applications-unlock": "/admin/awards/<pk>/manage/unlock/",
    "admin-awards-applications-update-award": "/admin/awards/<pk>/manage/updateaward/",
    "admin-awards-applications-update-custom": "/admin/awards/<pk>/manage/updatecustom/<submission_id>/<field_id>/",
    "admin-awards-assignments": "/admin/awards/<pk>/manage/assignments/",
    "admin-awards-assignments-clear-assignments": "/admin/awards/<pk>/manage/assignments/clear/assignments/",
    "admin-awards-assignments-clear-reviews": "/admin/awards/<pk>/manage/assignments/clear/reviews/",
    "admin-awards-assignments-details": "/admin/awards/<pk>/manage/assignments/details/",
    "admin-awards-assignments-manual-create": "/admin/awards/<pk>/manage/assignments/<round_id>/manual/create/",
    "admin-awards-assignments-manual-distribution-precalc": "/admin/awards/<pk>/manage/assignments/distribution/manual/precalc/",
    "admin-awards-assignments-manual-grid": "/admin/awards/<pk>/manage/assignments/<round_id>/manual/grid/",
    "admin-awards-assignments-member-assignment-data-export": "/admin/awards/<pk>/manage/assignments/<round_id>/teams/<team_id>/reviewer/<user_id>/export/",
    "admin-awards-assignments-reviewer-assignment-data": "/admin/awards/<pk>/manage/assignments/<round_id>/reviewers/<user_id>/",
    "admin-awards-assignments-reviewer-assignment-data-export": "/admin/awards/<pk>/manage/assignments/<round_id>/reviewers/<user_id>/export/",
    "admin-awards-assignments-reviewer-conflict-add": "/admin/awards/<pk>/manage/assignments/<round_id>/conflicts/<submission_id>/<reviewer_id>/",
    "admin-awards-assignments-reviewer-conflict-view": "/admin/awards/<pk>/manage/assignments/<round_id>/conflicts/<submission_id>/<reviewer_id>/remove/",
    "admin-awards-assignments-reviewer-reopen": "/admin/awards/<pk>/manage/assignments/<reviewer_id>/reopen/",
    "admin-awards-assignments-reviewer-submit": "/admin/awards/<pk>/manage/assignments/<reviewer_id>/submit/",
    "admin-awards-assignments-reviewer-unassign": "/admin/awards/<pk>/manage/assignments/reviewer/<user_id>/unassign/",
    "admin-awards-assignments-reviewers-data": "/admin/awards/<pk>/manage/assignments/<round_id>/reviewers/",
    "admin-awards-assignments-team-assignment-data-export": "/admin/awards/<pk>/manage/assignments/<round_id>/teams/<team_id>/export/",
    "admin-awards-assignments-team-clear-reviews": "/admin/awards/<pk>/manage/assignments/clear/team/reviews/",
    "admin-awards-assignments-team-details": "/admin/awards/<pk>/manage/assignments/team/<team_id>/details/",
    "admin-awards-assignments-team-member-assignment-data": "/admin/awards/<pk>/manage/assignments/<round_id>/teams/<team_id>/reviewer/<user_id>/",
    "admin-awards-assignments-team-unassign": "/admin/awards/<pk>/manage/assignments/team/<team_id>/unassign/",
    "admin-awards-assignments-teams-assignment-data": "/admin/awards/<pk>/manage/assignments/<round_id>/teams/<team_id>/",
    "admin-awards-assignments-teams-data": "/admin/awards/<pk>/manage/assignments/<round_id>/teams/",
    "admin-awards-award-decision": "/admin/awards/<pk>/manage/award/award-decision",
    "admin-awards-award-decision-meta": "/admin/awards/<pk>/manage/award/award-decision-meta",
    "admin-awards-bulk-task-reset": "/admin/awards/<pk>/manage/rst/bulk/",
    "admin-awards-categories-add": "/admin/awards/categories/add/",
    "admin-awards-categories-checkbox-source": "/admin/awards/categories/checkbox-source/",
    "admin-awards-categories-delete": "/admin/awards/categories/delete/",
    "admin-awards-categories-list": "/admin/awards/categories/list/",
    "admin-awards-categories-rename": "/admin/awards/categories/rename/",
    "admin-awards-categories-update-award": "/admin/awards/categories/update-award/",
    "admin-awards-change-collaborator-access": "/admin/awards/<pk>/manage/app/<app_id>/ca/<member_id>/",
    "admin-awards-dashboard": "/admin/awards/<pk>/manage/dashboard/",
    "admin-awards-dashboard-dates": "/admin/awards/<pk>/manage/dashboard/dates/",
    "admin-awards-dashboard-progress": "/admin/awards/<pk>/manage/dashboard/progress/",
    "admin-awards-dashboard-reviews": "/admin/awards/<pk>/manage/dashboard/reviews/",
    "admin-awards-dashboard-stages": "/admin/awards/<pk>/manage/dashboard/stages/",
    "admin-awards-dashboard-stats": "/admin/awards/<pk>/manage/dashboard/stats/",
    "admin-awards-delete": "/admin/awards/delete/",
    "admin-awards-duplicate": "/admin/awards/duplicate/",
    "admin-awards-edit": "/admin/awards/<award_id>/",
    "admin-awards-edit-budget-detail": "/admin/awards/<pk>/budget/",
    "admin-awards-eligibility-clear": "/admin/awards/<award_id>/eligibility/clear/",
    "admin-awards-eligibility-criteria": "/admin/awards/<award_id>/eligibility/criteria/",
    "admin-awards-eligibility-list": "/admin/awards/eligibility-list/",
    "admin-awards-eligibility-quiz": "/admin/settings/eligibility/",
    "admin-awards-eligibility-quiz-create": "/admin/settings/eligibility/create/",
    "admin-awards-eligibility-quiz-delete": "/admin/settings/eligibility/delete/",
    "admin-awards-eligibility-quiz-edit": "/admin/settings/eligibility/edit/",
    "admin-awards-eligibility-quiz-request-update": "/admin/settings/eligibility/requestupdate/",
    "admin-awards-eligibility-quiz-unlock-profiles": "/admin/settings/eligibility/unlockprofiles/",
    "admin-awards-export": "/admin/awards/export/",
    "admin-awards-fullexport": "/admin/awards/fullexport/<award_id>/",
    "admin-awards-fullexport-check": "/admin/awards/fullexport/<award_id>/check/",
    "admin-awards-fullimport": "/admin/awards/fullimport/",
    "admin-awards-import": "/admin/awards/import/",
    "admin-awards-listing-availability": "/admin/awards/listing-availability/",
    "admin-awards-make-hidden": "/admin/awards/make-hidden/",
    "admin-awards-make-live": "/admin/awards/make-live/",
    "admin-awards-make-offline": "/admin/awards/make-offline/",
    "admin-awards-make-owner": "/admin/awards/<pk>/manage/app/<app_id>/chown/<member_id>/",
    "admin-awards-make-visible": "/admin/awards/make-visible/",
    "admin-awards-manage": "/admin/awards/<pk>/manage/",
    "admin-awards-manage-budget-detail": "/admin/awards/<pk>/manage/budget/",
    "admin-awards-remove-collaborator": "/admin/awards/<pk>/manage/app/rm/<app_id>/col/<member_id>/",
    "admin-awards-remove-team": "/admin/awards/<pk>/manage/app/rm/<app_id>/team/<team_id>/",
    "admin-awards-revert-delete": "/admin/awards/revert/",
    "admin-awards-round-triggers-list": "/admin/awards/<award_id>/automations/list-round-triggers/<round_id>/",
    "admin-awards-task-record-offline-response": "/admin/awards/<pk>/manage/task_records/<task_record_id>/offline_response/",
    "admin-awards-triggers-action-choices": "/admin/awards/<award_id>/automations/action/choices/",
    "admin-awards-triggers-action-form": "/admin/awards/<award_id>/automations/action/<action_type_id>/form/",
    "admin-awards-triggers-activate": "/admin/awards/<award_id>/automations/activate/",
    "admin-awards-triggers-attachment-add": "/admin/awards/<award_id>/automations/attachment/add/",
    "admin-awards-triggers-attachments-get": "/admin/awards/<award_id>/automations/<trigger_id>/action/<action_id>/atts/",
    "admin-awards-triggers-conditions": "/admin/awards/<award_id>/automations/<trigger_id>/edit/conditions/",
    "admin-awards-triggers-conditions-filter-info": "/admin/awards/<award_id>/automations/conditions/filtersinfo/",
    "admin-awards-triggers-deactivate": "/admin/awards/<award_id>/automations/deactivate/",
    "admin-awards-triggers-delete": "/admin/awards/<award_id>/automations/delete/",
    "admin-awards-triggers-delete-template": "/admin/awards/<award_id>/automations/delete-template/<round_id>/",
    "admin-awards-triggers-duplicate": "/admin/awards/<award_id>/automations/duplicate/",
    "admin-awards-triggers-edit": "/admin/awards/<award_id>/automations/<trigger_id>/edit/",
    "admin-awards-triggers-edit-from-round": "/admin/awards/<award_id>/automations/<trigger_id>/edit/<round_id>/",
    "admin-awards-triggers-folders-add": "/admin/awards/<award_id>/automations/folders/add/",
    "admin-awards-triggers-folders-datasource": "/admin/awards/<award_id>/automations/folders/datasource/",
    "admin-awards-triggers-folders-delete": "/admin/awards/<award_id>/automations/folders/delete/",
    "admin-awards-triggers-folders-move": "/admin/awards/<award_id>/automations/folders/move/",
    "admin-awards-triggers-folders-rename": "/admin/awards/<award_id>/automations/folders/rename/",
    "admin-awards-triggers-list": "/admin/awards/<award_id>/automations/",
    "admin-awards-triggers-list-datasource": "/admin/awards/<award_id>/automations/list-datasource/",
    "admin-awards-triggers-log": "/admin/awards/<award_id>/automations/log/",
    "admin-awards-triggers-new": "/admin/awards/<award_id>/automations/new/",
    "admin-awards-triggers-new-from-template": "/admin/awards/<award_id>/automations/new_from_template/<round_id>/<template_id>/",
    "admin-awards-triggers-remove-from-folder": "/admin/awards/<award_id>/automations/remove-from-folder/",
    "admin-awards-workflow": "/admin/awards/<award_id>/workflow/",
    "admin-awards-workflow-new": "/admin/awards/<award_id>/workflow/new/",
    "admin-awards-workflow-rounds": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/",
    "admin-awards-workflow-rounds-add": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/add/",
    "admin-awards-workflow-rounds-indexes": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/indexes/",
    "admin-awards-workflow-rounds-round": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/",
    "admin-awards-workflow-rounds-round-assignment-rule-activate": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/<rule_id>/act/",
    "admin-awards-workflow-rounds-round-assignment-rule-delete": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/<rule_id>/d/",
    "admin-awards-workflow-rounds-round-assignment-rules": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/",
    "admin-awards-workflow-rounds-round-assignment-rules-edit": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/<rule_id>/",
    "admin-awards-workflow-rounds-round-assignments": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/",
    "admin-awards-workflow-rounds-round-assignments-list": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/list/",
    "admin-awards-workflow-rounds-round-assignments-order": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/order/",
    "admin-awards-workflow-rounds-round-assignments-remaining": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/rem/",
    "admin-awards-workflow-rounds-round-assignments-removeteams": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/removeteams/",
    "admin-awards-workflow-rounds-round-assignments-rules-list": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/list/",
    "admin-awards-workflow-rounds-round-assignments-rules-rem": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/rem/",
    "admin-awards-workflow-rounds-round-assignments-settings": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/settings/",
    "admin-awards-workflow-rounds-round-delete": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/delete/",
    "admin-awards-workflow-rounds-round-duplicate": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/duplicate/",
    "admin-awards-workflow-rounds-round-duplicate-status": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/duplicate/status/",
    "admin-awards-workflow-rounds-round-evaluation": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/evaluation/",
    "admin-awards-workflow-rounds-round-messages": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/messages/",
    "admin-awards-workflow-rounds-round-rename": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/rename/",
    "admin-awards-workflow-rounds-round-reviewer-configure": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/configure/",
    "admin-awards-workflow-rounds-round-reviewer-form-remove": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/remove/",
    "admin-awards-workflow-rounds-round-settings": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/settings/",
    "admin-awards-workflow-rounds-round-visibility": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/visibility/",
    "admin-awards-workflow-rounds-task-list": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/",
    "admin-awards-workflow-rounds-task-list-edit": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/edit/",
    "admin-awards-workflow-rounds-task-list-indexes": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/indexes/",
    "admin-awards-workflow-rounds-task-list-task-add": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/edit/task/add/<task_type>/",
    "admin-awards-workflow-rounds-task-list-task-convert": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/edit/task/<task_id>/convert/",
    "admin-awards-workflow-rounds-task-list-task-delete": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/task/<task_id>/delete/",
    "admin-awards-workflow-rounds-task-list-task-duplicate": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/task/<task_id>/duplicate/",
    "admin-awards-workflow-rounds-task-list-task-edit": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/edit/task/<task_id>/",
    "admin-awards-workflow-rounds-task-list-task-instance-global": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/task/<task_id>/instanceglobal/",
    "admin-awards-workflow-rounds-task-list-task-move": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/task/<task_id>/move/<new_round_id>/",
    "admin-awards-workflow-rounds-task-list-task-reuse": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/task/<task_id>/reuse/",
    "admin-awards-workflow-rounds-task-list-task-save": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/edit/task/save/",
    "admin-awards-workflow-rounds-task-selector-list": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/taskslist/",
    "admin-dashboard": "/admin/dashboard/",
    "admin-dashboard-unlock": "/admin/dashboard/unlock/",
    "admin-dataexport-columns": "/admin/dataexports/columns/<pk>/",
    "admin-dataexports-duplicate": "/admin/dataexports/duplicate/",
    "admin-dataexports-edit": "/admin/dataexports/edit/<pk>/",
    "admin-dataexports-filters": "/admin/dataexports/filters/<pk>/",
    "admin-dataexports-home": "/admin/dataexports/",
    "admin-dataexports-progress": "/admin/dataexports/progress/<pk>/",
    "admin-dataexports-updatelabels": "/admin/dataexports/labels/update/",
    "admin-financial-management-fund-balance": "/admin/financial-management/funds/<fund_id>/balance/",
    "admin-financial-management-fund-bulk-deposit": "/admin/financial-management/funds/deposit/",
    "admin-financial-management-fund-bulk-withdrawal": "/admin/financial-management/funds/withdrawal/",
    "admin-financial-management-fund-deposit": "/admin/financial-management/funds/<fund_id>/deposit/",
    "admin-financial-management-fund-detail": "/admin/financial-management/funds/<fund_id>/detail/",
    "admin-financial-management-fund-stats": "/admin/financial-management/funds/<fund_id>/stats/",
    "admin-financial-management-fund-transfer": "/admin/financial-management/funds/<fund_id>/transfer/",
    "admin-financial-management-fund-transfer-datasource": "/admin/financial-management/funds/transfer/datasource/",
    "admin-financial-management-fund-withdrawal": "/admin/financial-management/funds/<fund_id>/withdrawal/",
    "admin-financial-management-funds": "/admin/financial-management/funds/",
    "admin-financial-management-funds-active-columns": "/admin/financial-management/funds/columns/active/",
    "admin-financial-management-funds-archive": "/admin/financial-management/funds/archive/",
    "admin-financial-management-funds-archived-columns": "/admin/financial-management/funds/columns/archived/",
    "admin-financial-management-funds-create": "/admin/financial-management/funds/create/",
    "admin-financial-management-funds-delete": "/admin/financial-management/funds/delete/",
    "admin-financial-management-funds-edit-fund-folder": "/admin/financial-management/funds/<fund_id>/move-folder/",
    "admin-financial-management-funds-export": "/admin/financial-management/funds/export/",
    "admin-financial-management-funds-folder-delete": "/admin/financial-management/funds/folders/<folder_id>/delete/",
    "admin-financial-management-funds-folder-rename": "/admin/financial-management/funds/folders/<folder_id>/rename/",
    "admin-financial-management-funds-folders-add": "/admin/financial-management/funds/folders/add/",
    "admin-financial-management-funds-folders-datasource": "/admin/financial-management/funds/folders/datasource/",
    "admin-financial-management-funds-import": "/admin/financial-management/funds/import/",
    "admin-financial-management-funds-move-folder": "/admin/financial-management/funds/move-folder/",
    "admin-financial-management-funds-restore": "/admin/financial-management/funds/restore/",
    "admin-financial-management-funds-trash": "/admin/financial-management/funds/trash/",
    "admin-financial-management-funds-trashed-columns": "/admin/financial-management/funds/columns/trashed/",
    "admin-financial-management-program-balances-update": "/admin/financial-management/program-budgets/update-balances/",
    "admin-financial-management-program-balances-update-template": "/admin/financial-management/program-budgets/update-balances/template/",
    "admin-financial-management-program-budget-balance": "/admin/financial-management/program-budgets/<budget_id>/balance/",
    "admin-financial-management-program-budget-bulk-deposit": "/admin/financial-management/program-budgets/deposit/",
    "admin-financial-management-program-budget-bulk-withdrawal": "/admin/financial-management/program-budgets/withdrawal/",
    "admin-financial-management-program-budget-deposit": "/admin/financial-management/program-budgets/<budget_id>/deposit/",
    "admin-financial-management-program-budget-export": "/admin/financial-management/program-budgets/export/",
    "admin-financial-management-program-budget-stats": "/admin/financial-management/program-budgets/<budget_id>/stats/",
    "admin-financial-management-program-budget-transfer": "/admin/financial-management/program-budgets/<budget_id>/transfer/",
    "admin-financial-management-program-budget-transfer-datasource": "/admin/financial-management/program-budgets/transfer/datasource/",
    "admin-financial-management-program-budget-withdrawal": "/admin/financial-management/program-budgets/<budget_id>/withdrawal/",
    "admin-financial-management-program-budgets": "/admin/financial-management/program-budgets/",
    "admin-financial-management-program-budgets-columns": "/admin/financial-management/program-budgets/columns/",
    "admin-financial-management-transaction-edit": "/admin/financial-management/transactions/<transaction_id>/edit/",
    "admin-financial-management-transactions": "/admin/financial-management/transactions/",
    "admin-global-task-edit": "/admin/reusabletask/edit/",
    "admin-global-task-form-edit": "/admin/reusable/form/<task_id>/",
    "admin-organizations-activate": "/admin/users/org/activate/",
    "admin-organizations-add": "/admin/users/org/add/",
    "admin-organizations-application-detail-panel": "/admin/users/org/<pk>/panel/app/",
    "admin-organizations-deactivate": "/admin/users/org/deactivate/",
    "admin-organizations-detail": "/admin/users/org/<pk>/",
    "admin-organizations-detail-panel": "/admin/users/org/<pk>/panel/",
    "admin-organizations-edit-customfields": "/admin/users/org/<pk>/editcustomfields/",
    "admin-organizations-eligibility-rendered": "/admin/users/org/<pk>/eligibility/rendered/",
    "admin-organizations-export": "/admin/users/org/export/",
    "admin-organizations-get-customfields": "/admin/users/org/<pk>/customfields/",
    "admin-organizations-import": "/admin/users/org/import/",
    "admin-organizations-invite": "/admin/users/org/invite/",
    "admin-organizations-remove": "/admin/users/org/remove/",
    "admin-permissions": "/admin/permissions/",
    "admin-permissions-admins-add": "/admin/permissions/admins/add/",
    "admin-permissions-admins-datasource": "/admin/permissions/admins/datasource/",
    "admin-permissions-admins-delete": "/admin/permissions/admins/delete/",
    "admin-permissions-admins-edit-permissions": "/admin/permissions/admins/edit/permissions/",
    "admin-permissions-admins-edit-programaccess": "/admin/permissions/admins/edit/programaccess/",
    "admin-permissions-admins-invite": "/admin/permissions/admins/invite/",
    "admin-permissions-admins-primary": "/admin/permissions/admins/primary/<pk>/",
    "admin-permissions-delete": "/admin/permissions/delete/<pk>/",
    "admin-permissions-duplicate": "/admin/permissions/duplicate/<pk>/",
    "admin-permissions-edit": "/admin/permissions/edit/<pk>/",
    "admin-permissions-rename": "/admin/permissions/rename/<pk>/",
    "admin-permissions-roles-add": "/admin/permissions/roles/add/",
    "admin-reports": "/admin/reports/",
    "admin-search": "/admin/search/",
    "admin-settings-clear-eligibility-cache": "/admin/settings/clear_eligibility_cache/",
    "admin-settings-customfields": "/admin/settings/metadata/",
    "admin-settings-customfields-check": "/admin/settings/metadata/check/",
    "admin-settings-customfields-remove": "/admin/settings/metadata/remove/<pk>/",
    "admin-settings-dataimport": "/admin/settings/data_import_status/",
    "admin-settings-dataimport-award-status": "/admin/settings/data_import_status/<award_id>/",
    "admin-settings-dataimport-delete": "/admin/settings/data_import_delete/",
    "admin-settings-dataimport-import": "/admin/settings/data_import_import/<award_id>/",
    "admin-settings-dataimport-template": "/admin/settings/data_import_template/<award_id>/",
    "admin-settings-dataimport-upload": "/admin/settings/data_import_upload/",
    "admin-settings-dataimport-validate": "/admin/settings/data_import_validate/<award_id>/",
    "admin-settings-emails": "/admin/emails/",
    "admin-settings-emails-attachments": "/admin/emails/attachments/edit/",
    "admin-settings-emails-create": "/admin/emails/create/",
    "admin-settings-emails-domains-validate": "/admin/emails/domains/validate/",
    "admin-settings-emails-domains-validate-inline": "/admin/emails/domains/validate-inline/",
    "admin-settings-emails-logs": "/admin/emails/logs/",
    "admin-settings-emails-organization-create": "/admin/emails/org/create/",
    "admin-settings-emails-scheduled-delete": "/admin/emails/logs/schd/<pk>/d/",
    "admin-settings-emails-sender-default": "/admin/emails/sender/default/",
    "admin-settings-emails-sender-edit": "/admin/emails/sender/edit/",
    "admin-settings-emails-sender-list": "/admin/emails/sender/list/",
    "admin-settings-emails-submission-create": "/admin/emails/sub/create/",
    "admin-settings-emails-template-edit": "/admin/emails/templates/edit/",
    "admin-settings-emails-template-list": "/admin/emails/templates/list/",
    "admin-settings-files": "/admin/settings/files/",
    "admin-settings-files-delete": "/admin/settings/files/delete/",
    "admin-settings-files-detail": "/admin/settings/files/detail/<id>/",
    "admin-settings-files-upload": "/admin/settings/files/upload/",
    "admin-settings-general": "/admin/settings/general/",
    "admin-settings-generate-template": "/admin/settings/generate_template/",
    "admin-settings-global-tasks": "/admin/settings/reusabletasks/",
    "admin-settings-global-tasks-add-to-stages": "/admin/settings/reusabletasks/addtostages/",
    "admin-settings-global-tasks-datasource": "/admin/settings/reusabletasks/datasource/",
    "admin-settings-global-tasks-delete": "/admin/settings/reusabletasks/delete/",
    "admin-settings-global-tasks-duplicate": "/admin/settings/reusabletasks/duplicate/",
    "admin-settings-integrations": "/admin/settings/integrations/",
    "admin-settings-integrations-api-credentials": "/admin/settings/integrations/apply_connect/credentials/",
    "admin-settings-integrations-docusign": "/admin/settings/integrations/docusign/",
    "admin-settings-integrations-docusign-connect": "/admin/settings/integrations/docusign/connect/",
    "admin-settings-integrations-docusign-connection-detail": "/admin/settings/integrations/docusign/connections/<connection_id>/",
    "admin-settings-integrations-docusign-finish-setup": "/admin/settings/integrations/docusign/connections/<connection_id>/finish-setup/",
    "admin-settings-integrations-docusign-program-set-connection": "/admin/settings/integrations/docusign/programs/<award_id>/set-connection/",
    "admin-settings-integrations-docusign-status": "/admin/settings/integrations/docusign/status/",
    "admin-settings-integrations-salesforce-action-activate": "/admin/settings/integrations/salesforce/<integration_id>/activate/<action_id>/",
    "admin-settings-integrations-salesforce-action-deactivate": "/admin/settings/integrations/salesforce/<integration_id>/deactivate/<action_id>/",
    "admin-settings-integrations-salesforce-action-pull": "/admin/settings/integrations/salesforce/<integration_id>/pull/<action_id>/",
    "admin-settings-integrations-salesforce-action-push": "/admin/settings/integrations/salesforce/<integration_id>/push/<action_id>/",
    "admin-settings-integrations-salesforce-bulk-action": "/admin/settings/integrations/salesforce/<integration_id>/bulk/",
    "admin-settings-integrations-salesforce-bulk-delete": "/admin/settings/integrations/salesforce/bulk_delete/",
    "admin-settings-integrations-salesforce-detail": "/admin/settings/integrations/salesforce/<integration_id>/",
    "admin-settings-integrations-salesforce-rename": "/admin/settings/integrations/salesforce/<integration_id>/rename/",
    "admin-settings-notifications": "/admin/settings/notifications/",
    "admin-settings-notifications-edit": "/admin/settings/notifications/edit/<name>/",
    "admin-settings-notifications-reset": "/admin/settings/notifications/reset/<name>/",
    "admin-settings-notifications-test-email": "/admin/settings/notifications/test_email/<name>/",
    "admin-settings-pages": "/admin/settings/pages/",
    "admin-settings-pages-applicant-dashboard": "/admin/settings/pages/a/dash/",
    "admin-settings-pages-applicant-opportunities": "/admin/settings/pages/a/opp/",
    "admin-settings-pages-create": "/admin/settings/pages/+/",
    "admin-settings-pages-list": "/admin/settings/pages/list/",
    "admin-settings-pages-preview": "/admin/settings/pages/preview/",
    "admin-settings-pages-reviewer-dashboard": "/admin/settings/pages/r/dash/",
    "admin-settings-piping-program-variables": "/admin/settings/piping-program-variables/",
    "admin-settings-piping-variables": "/admin/settings/piping-variables/",
    "admin-settings-privacy-upload": "/admin/settings/privacy_upload/",
    "admin-settings-registration": "/admin/settings/registration/",
    "admin-settings-superuser": "/admin/settings/superuser/",
    "admin-settings-translations-datasource": "/admin/settings/translations/datasource/",
    "admin-settings-translations-default": "/admin/settings/translations/default/",
    "admin-settings-translations-download": "/admin/settings/translations/download/<stringchoice>/",
    "admin-settings-translations-index": "/admin/settings/translations/",
    "admin-settings-translations-upload": "/admin/settings/translations/upload/",
    "admin-settings-translations-visibility": "/admin/settings/translations/visibility/",
    "admin-ssolog": "/admin/ssolog/",
    "admin-teams": "/admin/users/teams/",
    "admin-teams-add-users": "/admin/users/teams/add-users/",
    "admin-teams-create": "/admin/users/teams/create/",
    "admin-teams-delete": "/admin/users/teams/delete/<pk>/",
    "admin-teams-edit": "/admin/users/teams/edit/<pk>/",
    "admin-teams-remove-user": "/admin/users/teams/remove-user/<pk>/",
    "admin-teams-remove-users": "/admin/users/teams/remove-users/<pk>/",
    "admin-user-download-privacy": "/admin/users/<pk>/privacy_request/",
    "admin-users": "/admin/users/",
    "admin-users-activate": "/admin/users/activate/",
    "admin-users-add": "/admin/users/add/",
    "admin-users-add-reviewer": "/admin/users/add/r/",
    "admin-users-application-detail-panel": "/admin/users/<pk>/panel/app/",
    "admin-users-assume": "/admin/users/<pk>/assume/",
    "admin-users-columns": "/admin/users/users/columns/",
    "admin-users-columns-applicant": "/admin/users/applicant/columns/",
    "admin-users-columns-organization": "/admin/users/organization/columns/",
    "admin-users-columns-recommender": "/admin/users/recommender/columns/",
    "admin-users-columns-reviewer": "/admin/users/reviewer/columns/",
    "admin-users-datasource": "/admin/users/datasource/",
    "admin-users-deactivate": "/admin/users/deactivate/",
    "admin-users-delete": "/admin/users/delete/",
    "admin-users-detail": "/admin/users/<pk>/",
    "admin-users-detail-panel": "/admin/users/<pk>/panel",
    "admin-users-edit-customfields": "/admin/users/<pk>/editcustomfields/",
    "admin-users-eligibility-rendered": "/admin/users/<pk>/eligibility/rendered/",
    "admin-users-export": "/admin/users/export/",
    "admin-users-get-customfields": "/admin/users/<pk>/customfields/",
    "admin-users-import": "/admin/users/import/",
    "admin-users-invite": "/admin/users/invite/",
    "admin-users-password-reset": "/admin/users/password/reset/",
    "admin-users-reviewer-conflicts-add": "/admin/users/reviewer/<reviewer_id>/conflicts/add/",
    "admin-users-reviewer-conflicts-delete": "/admin/users/reviewer/conflicts/<conflict_id>/rm/",
    "admin-users-reviewer-conflicts-list": "/admin/users/reviewer/<reviewer_id>/conflicts/list/",
    "admin-users-role-add": "/admin/users/role/add/",
    "admin-users-role-change": "/admin/users/role/change/",
    "admin-users-role-remove": "/admin/users/role/remove/",
    "api-internal-custom-field-list": "/internal/custom_fields/",
    "api-internal-languages": "/internal/languages/",
    "api-internal-login": "/internal/login/",
    "api-internal-login-token": "/internal/login-token/",
    "api-internal-mfa-challenge": "/internal/mfa/challenge/",
    "api-internal-mfa-change-device": "/internal/mfa/change/",
    "api-internal-mfa-enroll": "/internal/mfa/enroll/",
    "api-internal-mfa-recovery-email": "/internal/mfa/recovery-email/",
    "api-internal-mfa-remove": "/internal/mfa/remove/",
    "api-internal-password-reset": "/internal/password-reset/",
    "api-internal-register": "/internal/register/",
    "api-internal-timezones": "/internal/timezones/",
    "api-internal-user": "/internal/user/",
    "api-internal-user-profile-image": "/internal/user/image/",
    "api-smapply-activities": "/api/activity/",
    "api-smapply-activity": "/api/activity/<id>/",
    "api-smapply-apilog": "/api/log/",
    "api-smapply-application": "/api/applications/<id>/",
    "api-smapply-application-file": "/api/applications/<application_id>/tasks/<id>/files/<file_id>/",
    "api-smapply-application-file-creation": "/api/applications/<application_id>/tasks/<id>/files/",
    "api-smapply-application-note": "/api/applications/<application_id>/notes/<id>/",
    "api-smapply-application-notes": "/api/applications/<application_id>/notes/",
    "api-smapply-application-round-history": "/api/applications/<application_id>/stage_history/",
    "api-smapply-application-stage": "/api/applications/<application_id>/stages/<id>/",
    "api-smapply-application-stages": "/api/applications/<application_id>/stages/",
    "api-smapply-application-task": "/api/applications/<application_id>/tasks/<id>/",
    "api-smapply-application-tasks": "/api/applications/<application_id>/tasks/",
    "api-smapply-applications": "/api/applications/",
    "api-smapply-applicationtable": "/api/programs/<id>/applications/",
    "api-smapply-applicationtable-detail": "/api/programs/<award_id>/applications/<id>/",
    "api-smapply-assignments": "/api/assignments/",
    "api-smapply-automationtraces": "/api/automationtraces/",
    "api-smapply-budget": "/api/budgets/<id>/",
    "api-smapply-budgets": "/api/budgets/",
    "api-smapply-bulk-actions": "/api/bulk/",
    "api-smapply-customfield": "/api/customfields/<id>/",
    "api-smapply-customfields": "/api/customfields/",
    "api-smapply-dataexport": "/api/dataexports/<id>/",
    "api-smapply-dataexport-download": "/api/dataexports/<id>/download/",
    "api-smapply-dataexportjob": "/api/dataexportjobs/<id>/",
    "api-smapply-dataexportjobs": "/api/dataexportjobs/",
    "api-smapply-dataexports": "/api/dataexports/",
    "api-smapply-dataexportstatuses": "/api/dataexportstatuses/",
    "api-smapply-decision": "/api/awards/<id>/",
    "api-smapply-decisions": "/api/awards/",
    "api-smapply-drs": "/api/user_drs/",
    "api-smapply-favicon": "/api/favicon/",
    "api-smapply-financial-transaction": "/api/financial-transactions/<id>/",
    "api-smapply-financial-transactions": "/api/financial-transactions/",
    "api-smapply-fund": "/api/funds/<id>/",
    "api-smapply-fund-awards": "/api/funds/<fund_id>/awards/",
    "api-smapply-fund-transactions": "/api/funds/<fund_id>/transactions/",
    "api-smapply-funds": "/api/funds/",
    "api-smapply-jobs": "/api/jobs/",
    "api-smapply-logo": "/api/logo/",
    "api-smapply-oauth2-provider:authorize": "/api/o/authorize/",
    "api-smapply-oauth2-provider:authorized-token-delete": "/api/o/authorized_tokens/<slug:pk>/delete/",
    "api-smapply-oauth2-provider:authorized-token-list": "/api/o/authorized_tokens/",
    "api-smapply-oauth2-provider:delete": "/api/o/applications/<slug:pk>/delete/",
    "api-smapply-oauth2-provider:detail": "/api/o/applications/<slug:pk>/",
    "api-smapply-oauth2-provider:introspect": "/api/o/introspect/",
    "api-smapply-oauth2-provider:jwks-info": "/api/o/.well-known/jwks.json",
    "api-smapply-oauth2-provider:list": "/api/o/applications/",
    "api-smapply-oauth2-provider:oidc-connect-discovery-info": "/api/o/.well-known/openid-configuration/",
    "api-smapply-oauth2-provider:register": "/api/o/applications/register/",
    "api-smapply-oauth2-provider:revoke-token": "/api/o/revoke_token/",
    "api-smapply-oauth2-provider:rp-initiated-logout": "/api/o/logout/",
    "api-smapply-oauth2-provider:token": "/api/o/token/",
    "api-smapply-oauth2-provider:update": "/api/o/applications/<slug:pk>/update/",
    "api-smapply-oauth2-provider:user-info": "/api/o/userinfo/",
    "api-smapply-organization": "/api/organizations/<id>/",
    "api-smapply-organization-eligibility": "/api/organizations/<id>/eligibility/",
    "api-smapply-organization-member": "/api/organizations/<organization_id>/members/<id>/",
    "api-smapply-organization-members": "/api/organizations/<organization_id>/members/",
    "api-smapply-organization-team": "/api/organizations/<organization_id>/teams/<id>/",
    "api-smapply-organization-team-member": "/api/organizations/<organization_id>/teams/<team_id>/members/<id>/",
    "api-smapply-organization-team-members": "/api/organizations/<organization_id>/teams/<team_id>/members/",
    "api-smapply-organization-teams": "/api/organizations/<organization_id>/teams/",
    "api-smapply-organizations": "/api/organizations/",
    "api-smapply-payment": "/api/payments/<id>/",
    "api-smapply-payment-status": "/api/payment-statuses/<id>/",
    "api-smapply-payment-statuses": "/api/payment-statuses/",
    "api-smapply-payments": "/api/payments/",
    "api-smapply-program": "/api/programs/<id>/",
    "api-smapply-program-automationeventmap": "/api/programs/<program_id>/automationevents/<id>/",
    "api-smapply-program-automationevents": "/api/programs/<id>/automationevents/",
    "api-smapply-program-budgets": "/api/program-budgets/",
    "api-smapply-program-budgets-transactions": "/api/program-budgets/<award_id>/transactions/",
    "api-smapply-program-flow": "/api/programs/<program_id>/flow/",
    "api-smapply-programs": "/api/programs/",
    "api-smapply-report": "/api/reports/<id>/",
    "api-smapply-report-download": "/api/reports/<id>/download/",
    "api-smapply-reportjob": "/api/reportsjobs/<id>/",
    "api-smapply-reportjobs": "/api/reportsjobs/",
    "api-smapply-reportlabel": "/api/reportlabels/<id>/",
    "api-smapply-reportlabels": "/api/reportlabels/",
    "api-smapply-reports": "/api/reports/",
    "api-smapply-reportstatuses": "/api/reportsstatuses/",
    "api-smapply-review": "/api/reviews/<id>/",
    "api-smapply-reviews": "/api/reviews/",
    "api-smapply-site": "/api/site/",
    "api-smapply-site-custom-domain-detail": "/api/custom-domains/<domain>/",
    "api-smapply-site-custom-domain-list": "/api/custom-domains/",
    "api-smapply-sitestatistics": "/api/sitestatistics/",
    "api-smapply-ssolog": "/api/ssolog/",
    "api-smapply-stage": "/api/stages/<id>/",
    "api-smapply-stage-custom-status": "/api/stages/<stage_id>/statuses/<id>/",
    "api-smapply-stage-custom-statuses": "/api/stages/<stage_id>/statuses/",
    "api-smapply-stages": "/api/stages/",
    "api-smapply-task": "/api/tasks/<id>/",
    "api-smapply-tasks": "/api/tasks/",
    "api-smapply-team": "/api/teams/<id>/",
    "api-smapply-team-member": "/api/teams/<team_id>/members/<id>/",
    "api-smapply-team-members": "/api/teams/<team_id>/members/",
    "api-smapply-teamassignments": "/api/teamassignments/",
    "api-smapply-teams": "/api/teams/",
    "api-smapply-uis": "/api/uis/",
    "api-smapply-uis-import": "/api/uisimports/<id>/",
    "api-smapply-uis-imports": "/api/uisimports/",
    "api-smapply-user": "/api/users/<id>/",
    "api-smapply-user-eligibility": "/api/users/<id>/eligibility/",
    "api-smapply-users": "/api/users/",
    "applicant-eligibility-edit": "/prog/eligibility/edit/",
    "application-completion-message": "/sub/<app_id>/cmp/round_id=<round_id>",
    "application-dashboard": "/prog/",
    "application-delete": "/sub/<app_id>/rmv/",
    "application-detail": "/sub/<app_id>/",
    "application-instructions": "/sub/<app_id>/inst/",
    "application-list-datasource": "/prog/app/ds/",
    "application-notes": "/a/<submission_id>/nts/",
    "application-rename": "/sub/<app_id>/ren",
    "application-save": "/sub/<app_id>/sv/",
    "application-submit-preview": "/sub/<app_id>/sprv/",
    "application-withdraw": "/sub/<app_id>/wd/",
    "cancel-email-change": "/acc/em/c/",
    "change-collaborator-access": "/sub/<app_id>/col/<member_id>/c/",
    "clear-application-needs-attention": "/sub/<app_id>/clear-needs-attention/",
    "connect-documentation": "/api/documentation/",
    "connect-openapi": "/api/openapi.yaml",
    "custom-domain-verification": "/domains/verification/",
    "delete-collaborator": "/sub/<app_id>/dc/",
    "diagnostics-reminder-emails-data": "/diagnostics/reminderemails/data/",
    "diagnostics-service-status": "/diagnostics/servicestatus/",
    "djdt:render_panel": "/__debug__/render_panel/",
    "djdt:sql_explain": "/__debug__/sql_explain/",
    "djdt:sql_profile": "/__debug__/sql_profile/",
    "djdt:sql_select": "/__debug__/sql_select/",
    "djdt:template_source": "/__debug__/template_source/",
    "domain-test": "/domains/test/",
    "download": "/dl/",
    "download-modal-data": "/dl/mdl/",
    "download-redirect": "/dlr/",
    "drafting": "/drafts/",
    "edit-applicant-award-decision": "/sub/<app_id>/decision/",
    "feature-request": "/featurerequest/",
    "filters-datasource": "/admin/filters/datasource/",
    "filters-delete": "/admin/filters/delete/",
    "filters-duplicate": "/admin/filters/duplicate/",
    "filters-get-filter": "/admin/filters/get/",
    "filters-index": "/admin/filters/",
    "filters-rename": "/admin/filters/rename/",
    "filters-save": "/admin/filters/save/",
    "filters-share": "/admin/filters/share/",
    "filters-unshare": "/admin/filters/unshare/",
    "get-collaborator-list": "/sub/<app_id>/gcl/",
    "get-collaborators": "/sub/<app_id>/gc/",
    "get-org-applicant-list": "/sub/<app_id>/gol/",
    "get-org-member-list": "/sub/<app_id>/gml/",
    "help-center": "/helpcenter/",
    "helpdesk": "/helpdesk/",
    "helpdesk-form-legacy": "/helpdesk/form/",
    "helpdesk-form-legacy-params": "/helpdesk/form/<selection>/",
    "in-gdpr-country": "/gdprgeo/",
    "make-collaborator-owner": "/sub/<app_id>/col/<member_id>/mo/",
    "mfa-faq": "/mfa/faq/",
    "mfa-index": "/mfa/",
    "mfa-learn-more": "/mfa/learn-more/",
    "mfa-lockout": "/mfa/locked-out/",
    "modify-collaborator": "/sub/<app_id>/mc/",
    "org-eligibility": "/org/e/",
    "org-files": "/org/f/",
    "org-members": "/org/m/",
    "org-members-access": "/org/m/a/",
    "org-members-activate": "/org/m/ac/",
    "org-members-add": "/org/m/add/",
    "org-members-data": "/org/m/d/",
    "org-members-deactivate": "/org/m/de/",
    "org-members-email": "/org/m/em/",
    "org-members-import": "/org/m/im/",
    "org-members-import-template": "/org/m/im/t/",
    "org-members-invite": "/org/m/in/",
    "org-members-remove": "/org/m/rm/",
    "org-members-role": "/org/m/r/",
    "org-members-teams": "/org/m/tm/",
    "org-profile": "/org/p/",
    "org-profile-cancel-delete-request": "/org/p/r/d/c/",
    "org-profile-delete-request": "/org/p/r/d/",
    "org-profile-logo": "/org/p/l/",
    "org-profile-logo-remove": "/org/p/l/r/",
    "org-profile-transfer": "/org/p/t/",
    "org-sites-data": "/org/s/",
    "org-switch-profile": "/org/sw/",
    "org-teams": "/org/t/",
    "org-teams-create": "/org/t/c/",
    "org-teams-data": "/org/t/d/",
    "org-teams-email": "/org/t/em/",
    "org-teams-members-data": "/org/t/<team_id>/d/",
    "org-teams-members-remove": "/org/t/<team_id>/rm/",
    "org-teams-panel": "/org/t/<team_id>/p/",
    "org-teams-remove": "/org/t/rm/",
    "org-teams-rename": "/org/t/n/",
    "pipes-index": "/admin/pipes/",
    "plan-features": "/admin/settings/plan_features/<plan_id>/",
    "privacy-url": "/privacy/",
    "program-apply": "/prog/<program_id>/apply/",
    "program-list": "/prog/lst/",
    "program-list-datasource": "/prog/ds/",
    "program-profile": "/prog/<listing_url>/",
    "quick-reference-complete": "/acc/rcmdr/qrcmplt",
    "recommenders-task-list": "/rcmdr/",
    "register": "/acc/r/",
    "register-organization": "/acc/o/",
    "remove-collaborator": "/sub/<app_id>/col/<member_id>/rm/",
    "remove-team": "/sub/<app_id>/col/<team_id>/rt/",
    "report-type-datasource": "/admin/reporttypes/",
    "resend-collaborator-invite": "/sub/<app_id>/col/<member_id>/rs/",
    "resend-email-confirmation": "/acc/em/rs/",
    "resend-email-verification": "/acc/em/vr/",
    "reviewer-conflict-delete": "/acc/rev/conflicts/<conflict_id>/rm/",
    "reviewer-conflict-list": "/acc/rev/conflicts/",
    "reviewers-assignments-columns": "/rev/a/<award_id>/r/<round_id>/cols/",
    "reviewers-assignments-list": "/rev/a/<award_id>/r/<round_id>/",
    "reviewers-assignments-list-data": "/rev/a/<award_id>/r/<round_id>/data/",
    "reviewers-assignments-needs-submit": "/rev/a/<award_id>/r/<round_id>/sbmt/ns/",
    "reviewers-assignments-reopen": "/rev/a/<award_id>/r/<round_id>/ro/",
    "reviewers-assignments-submit": "/rev/a/<award_id>/r/<round_id>/sbmt/",
    "reviewers-assignments-submit-page": "/rev/a/<award_id>/r/<round_id>/sbmt/p/",
    "reviewers-download-all-reviews": "/rev/dl/all/<award_id>/<round_id>/",
    "reviewers-index": "/rev/",
    "reviewers-report-conflict": "/rev/conflict/<submission_id>/",
    "reviewers-reset-task": "/rev/reset-task/<award_id>/<round_id>/",
    "reviewers-review-mode": "/rev/a/<award_id>/r/<round_id>/s/<submission_id>/",
    "reviewers-reviews-tab": "/rev/a/<award_id>/r/<round_id>/s/<submission_id>/tab",
    "reviewers-round-instructions": "/rev/a/<award_id>/r/<round_id>/instructions/",
    "reviewers-task-quick-edit": "/rev/a/<award_id>/r/<round_id>/e/<submission_id>/",
    "reviewroom-apiv2-organization-member-list": "/api/v2/organizations/<pk>/members.<format>/",
    "reviewroom-apiv2-round-detail-status-detail": "/api/v2/rounds/<pk>/statuses/<status_pk>.<format>/",
    "reviewroom-apiv2-round-detail-status-list": "/api/v2/rounds/<pk>/statuses.<format>/",
    "reviewroom-apiv2-submission-list": "/api/v2/submissions.<format>/",
    "reviewroom-apiv2-user-by-email": "/api/v2/user_by_email/<pk>.<format>/",
    "reviewroom-favicon": "/favicon/",
    "reviewroom-logo": "/logo/",
    "sf_index": "/admin/settings/integrations/salesforce_v4/",
    "sf_v4_auth_urls": "/admin/settings/integrations/salesforce_v4_api/auth_urls/",
    "sf_v4_automation": "/admin/settings/integrations/salesforce_v4_api/automations/<connection_pk>/<pk>/",
    "sf_v4_automation_get_run_jobs": "/admin/settings/integrations/salesforce_v4_api/automations/<connection_pk>/get_running_jobs/",
    "sf_v4_automation_run": "/admin/settings/integrations/salesforce_v4_api/automations/<connection_pk>/<pk>/run/",
    "sf_v4_automations": "/admin/settings/integrations/salesforce_v4_api/automations/<connection_pk>/",
    "sf_v4_automations_bulk": "/admin/settings/integrations/salesforce_v4_api/automations/<connection_pk>/bulk/",
    "sf_v4_callback": "/admin/settings/integrations/salesforce_v4_api/auth_callback/",
    "sf_v4_connection": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/",
    "sf_v4_connection_automation_schema": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/automation_schema/",
    "sf_v4_connection_mapping_schema": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/mapping_action_schema/",
    "sf_v4_connection_objects": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/objects/",
    "sf_v4_connection_reauth": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/reauth/",
    "sf_v4_connection_record_search": "/admin/settings/integrations/salesforce_v4_api/mapping_actions/<connection_pk>/<pk>/record_search/",
    "sf_v4_connection_refresh_schema": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/refresh-schema/",
    "sf_v4_connection_unique_object_names": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/unique_object_names/",
    "sf_v4_connections_list": "/admin/settings/integrations/salesforce_v4_api/connections/",
    "sf_v4_logs": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/logs/",
    "sf_v4_logs_rerun": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/logs/<log_pk>/rerun/",
    "sf_v4_mapping_action": "/admin/settings/integrations/salesforce_v4_api/mapping_actions/<connection_pk>/<pk>/",
    "sf_v4_mapping_actions": "/admin/settings/integrations/salesforce_v4_api/mapping_actions/<connection_pk>/",
    "sf_v4_mapping_actions_bulk": "/admin/settings/integrations/salesforce_v4_api/mapping_actions/<connection_pk>/bulk/",
    "sf_v4_program": "/admin/settings/integrations/salesforce_v4_api/programs/",
    "sf_v4_source": "/admin/settings/integrations/salesforce_v4_api/sources/",
    "sf_v4_unpaginated_mapping_actions": "/admin/settings/integrations/salesforce_v4_api/mapping_actions/<connection_pk>/unpaginated/",
    "signout": "/acc/lo/",
    "submission-admin-stage-preview": "/rend/<submission_id>/admin/st/<stage_id>/",
    "submission-admin-taskrecord-preview": "/rend/<submission_id>/admin/t/<task_record_id>/",
    "submission-details-preview": "/rend/<submission_id>/dt/",
    "submission-recommender-stage-preview": "/rend/<submission_id>/rec/st/<stage_id>/",
    "submission-reviewer-stage-preview": "/rend/<submission_id>/rev/st/<stage_id>/",
    "submission-stage-preview": "/rend/<submission_id>/st/<stage_id>/",
    "submission-taskrecord-preview": "/rend/<submission_id>/t/<task_record_id>/",
    "surveys-bulk": "/admin/surveys/bulk/",
    "surveys-datasource": "/admin/surveys/<survey_id>/datasource/",
    "surveys-download": "/admin/surveys/<survey_id>/download/",
    "surveys-pipes-datasource": "/admin/surveys/<survey_id>/pipesdatasource/",
    "surveys-preview": "/admin/surveys/<survey_id>/preview/",
    "surveys-preview-save": "/admin/surveys/<survey_id>/previewsave/",
    "surveys-question-check": "/admin/surveys/question-check/",
    "surveys-save": "/admin/surveys/<survey_id>/save/",
    "surveys-versions": "/admin/surveys/<survey_id>/versions/datasource/",
    "surveys-versions-revert": "/admin/surveys/<survey_id>/versions/<version_id>/revert/",
    "task-file-attachment-delete": "/tsk/<submission_id>/flup/<task_record_id>/delete/<file_attachment_id>/",
    "task-file-attachment-list": "/tsk/<submission_id>/flup/<task_record_id>/list/",
    "task-file-attachment-preview": "/tsk/<submission_id>/flup/<task_record_id>/preview/<file_attachment_id>/",
    "task-file-edit-file": "/tsk/<submission_id>/flup/<task_record_id>/e/file/<file_attachment_id>/",
    "task-file-edit-link": "/tsk/<submission_id>/flup/<task_record_id>/e/link/<file_attachment_id>/",
    "task-file-upload-file": "/tsk/<submission_id>/flup/<task_record_id>/upload/file/",
    "task-file-upload-link": "/tsk/<submission_id>/flup/<task_record_id>/upload/link/",
    "task-global-reuse": "/tsk/<submission_id>/gt/<task_record_id>/",
    "task-reopen": "/tsk/<submission_id>/rpn/<task_record_id>/",
    "task-reset": "/tsk/<submission_id>/rst/<task_record_id>/",
    "token-expiredlink": "/acc/token-expired/",
    "tos-url": "/tos/",
    "user-alerts": "/acc/alerts/"
};

function reverse(urlname, kwargs) {
	var url = viewnames[urlname];
	kwargs = kwargs || {};

	if (url === undefined) {
		throw 'reverse failed. Incorrect urlname: ' + urlname;
	}

	for(var kwarg in kwargs) {
		var value = kwargs[kwarg];
		url = url.replace('<' + kwarg + '>', value);
	}
	if (url.includes('<')) {
		throw 'reverse failed. Missing kwargs. urlname: ' + urlname + '. kwargs: ' + JSON.stringify(kwargs) + '. url: ' + url;
	}
	return url;
}
window.reverse = reverse;
